import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import Typography from 'carbon-react/lib/components/typography';

import * as styles from './help-link-section.scss';

export interface HelpLinkSectionProps {
  title: ReactNode;
  href: string;
}

export const HelpLinkSection = ({ title, href }: HelpLinkSectionProps) => (
  <>
    <Box mb={3} height="1px" width="100%" backgroundColor="#CCD6DB" />
    <Box mt={3}>
      <Typography fontSize="14px" fontWeight="500" lineHeight="150%" mb={0}>
        {title}
      </Typography>
      <Typography fontSize="14px" color="rgba(0, 0, 0, 0.65)">
        <FormattedMessage
          id="reporting.click_here_for_help_link"
          defaultMessage="<link>Click here</link> for help getting started"
          values={{
            link: (chunks: React.ReactNode) => (
              <a
                href={href}
                target="_blank"
                rel="noreferrer noopener"
                className={styles.helpLink}
              >
                {chunks}
              </a>
            )
          }}
        />
      </Typography>
    </Box>
  </>
);
